import { api } from './Api'

class BudowniczyService {
  getList() {
    return api.get('budowniczy/getList.php');
  }
}

export const budowniczyService = new BudowniczyService();